import { iAccess } from "../../../definitions/Access"
import { iSubRoute } from "../../../definitions/interfaces"
import { iPermission } from "../../../store/permissions/types"
import { iUserInitialData } from "../../../store/user/types"

interface iProps {
  urlPrefix: string
  access?: iAccess
  user?: iUserInitialData
  permissions?: iPermission[]
  type?: string
}

export function getArtPieceRoutes({
  urlPrefix = "",
  access,
  user,
  permissions,
  type,
}: iProps): iSubRoute[] {
  const r = routes.map((route) => {
    if (!permissions?.find((p) => p.name === "Dashboard.Admin")) {
      if (route.permission) {
        const usr = access?.users.find((x) => x._id === user?._id)
        if (!usr || usr.role !== route.permission) {
          return null
        }
      }
    }
    if (route.type && (!type || type !== route.type)) {
      return null
    }
    return { ...route, route: urlPrefix + route.route }
  })

  return r.filter((x) => x !== null) as iSubRoute[]
}

const routes: iSubRoute[] = [
  {
    title: "Overview",
    route: "",
  },
  {
    title: "Details",
    route: "/painting",
    type: "PAINTING",
  },
  {
    title: "Details",
    route: "/sculpture",
    type: "SCULPTURE",
  },
  {
    title: "Details",
    route: "/drawing",
    type: "DRAWING",
  },
  {
    title: "Details",
    route: "/print",
    type: "PRINT",
  },
  {
    title: "Details",
    route: "/photography",
    type: "PHOTOGRAPHY",
  },
  {
    title: "Details",
    route: "/video",
    type: "VIDEO",
  },
  {
    title: "Details",
    route: "/street-art",
    type: "STREETART",
  },
  {
    title: "Details",
    route: "/audio",
    type: "AUDIO",
  },
  {
    title: "Uploads",
    route: "/manage-files",
  },
  {
    title: "Sale info",
    route: "/sale-info",
  },
  {
    title: "Access",
    route: "/access",
    permission: "owner",
  },
]
